import React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

import { colors } from "@/theme/overrides/colors";

const CaloriesBurnedIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 21 20" {...props}>
      <path
        d="M17.1344 10.5016C15.826 7.10158 11.1677 6.91825 12.2927 1.97658C12.376 1.60992 11.9844 1.32658 11.6677 1.51825C8.64271 3.30158 6.46771 6.87658 8.29271 11.5599C8.44271 11.9432 7.99271 12.3016 7.66771 12.0516C6.15938 10.9099 6.00104 9.26825 6.13438 8.09325C6.18438 7.65992 5.61771 7.45158 5.37604 7.80992C4.80937 8.67658 4.23438 10.0766 4.23438 12.1849C4.55104 16.8516 8.49271 18.2849 9.90938 18.4683C11.9344 18.7266 14.126 18.3516 15.701 16.9099C17.4344 15.3016 18.0677 12.7349 17.1344 10.5016ZM9.40104 14.6932C10.601 14.4016 11.2177 13.5349 11.3844 12.7682C11.6594 11.5766 10.5844 10.4099 11.3094 8.52658C11.5844 10.0849 14.0344 11.0599 14.0344 12.7599C14.101 14.8682 11.8177 16.6766 9.40104 14.6932Z"
        fill="#4C515A"
      />
      <path
        d="M17.1344 10.5016C15.826 7.10158 11.1677 6.91825 12.2927 1.97658C12.376 1.60992 11.9844 1.32658 11.6677 1.51825C8.64271 3.30158 6.46771 6.87658 8.29271 11.5599C8.44271 11.9432 7.99271 12.3016 7.66771 12.0516C6.15938 10.9099 6.00104 9.26825 6.13438 8.09325C6.18438 7.65992 5.61771 7.45158 5.37604 7.80992C4.80937 8.67658 4.23438 10.0766 4.23438 12.1849C4.55104 16.8516 8.49271 18.2849 9.90938 18.4683C11.9344 18.7266 14.126 18.3516 15.701 16.9099C17.4344 15.3016 18.0677 12.7349 17.1344 10.5016ZM9.40104 14.6932C10.601 14.4016 11.2177 13.5349 11.3844 12.7682C11.6594 11.5766 10.5844 10.4099 11.3094 8.52658C11.5844 10.0849 14.0344 11.0599 14.0344 12.7599C14.101 14.8682 11.8177 16.6766 9.40104 14.6932Z"
        fill={colors.gray}
      />
    </SvgIcon>
  );
};

export default CaloriesBurnedIcon;
